import device from 'bits/device'
import appCan from 'bits/app_can'
import getCsrfToken from 'bits/csrf_token'
import { browserCan } from 'bits/browser'
import { isFullscreen } from 'bits/fullscreen'
import window, { ww } from 'bits/global'
import { Cid } from 'types'
import { getCookie } from 'bits/cookie'

function getStartingExpandedPostCid (): Cid | null {
  if (window.location.pathname.split('/').length === 5) {
    return 'c' + window.location.pathname.split('/')[4]
  }
  return null
}

export default (): any => ({
  /* BROWSER VARIABLES */
  isFullscreen: isFullscreen(),
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,

  /* CONSTANTS */
  canPostMessage: device.can('postMessage'),
  cookiesEnabled: browserCan('cookiesForReal'),
  csrfToken: getCsrfToken(),
  deviceId: getCookie('ww_d'),
  dpr: Math.ceil(window.devicePixelRatio) || 1,
  environment: document.documentElement.dataset.environment,
  inlinePostEdit: !device.mobile,
  isAndroid: device.android,
  isApp: device.app,
  isChrome: device.chrome,
  isDesktop: device.desktop,
  isEdge: device.edge,
  isFirefox: device.firefox,
  isIE: device.ie,
  isIOS: device.ios,
  isIPhone: device.iphone,
  isIPhoneX: device.iphoneX,
  isMac: device.mac,
  isMobile: device.mobile,
  isMousable: device.mousable,
  isOldApp: device.app && device.cannot('postNatively'),
  isPhone: device.phone,
  isSafari: device.safari,
  isTablet: device.tablet,
  isTouchable: device.touchable,
  isWindows: device.windows,
  locale: document.documentElement.lang,
  modalPostEdit: device.mobile && !(device.app && device.can('postNatively')),
  nativePostEdit: device.app && device.can('postNatively'),
  release: document.documentElement.dataset.version,
  showAlertSheet: device.can('showAlertSheet'),
  uid: ww.uid,
  xHeader: !device.app || !appCan('useNativeHeader'),

  /* MODULES */
  expandedPostCid: getStartingExpandedPostCid(),
})
